import axios from "axios";

export const fetchProfile = () => axios.get("/api/v1/developers/me");
export const registerDeveloper = (userId, data) =>
    axios.patch(`/api/v1/developers/${userId}`, data);
export const fetchDeveloperApps = userId =>
    axios.get(`/api/v1/developers/${userId}/apps`);
export const fetchDeveloperProjects = userId =>
    axios.get(`/api/v1/developers/${userId}/projects`);
export const unregisterProject = (userId, projectId) =>
    axios.delete(
        `/api/v1/developers/${userId}/projects/${projectId}/members/me`
    );
export const withdrawProject = projectId =>
    axios.delete(`/api/v1/projects/${projectId}/members/me`);

export const logout = () => axios.post("/api/v1/auth/logout");
export const deleteAccount = () => axios.delete("/api/v1/auth/users/me");

export const fetchAllProjects = () => axios.get("/api/v1/projects");
export const fetchProjectDetail = projectId =>
    axios.get(`/api/v1/projects/${projectId}`);
export const updateProject = (projectId, data) =>
    axios.patch(`/api/v1/projects/${projectId}`, data);
export const registerProject = data => axios.post("/api/v1/projects", data);
export const addMembers = (projectId, params, data) =>
    axios.post(`/api/v1/projects/${projectId}/members`, data, { params });
export const updateMemberType = (projectId, params, data) =>
    axios.patch(`/api/v1/projects/${projectId}/members`, data, { params });
export const deleteMembers = (projectId, params) =>
    axios.delete(`/api/v1/projects/${projectId}/members`, { params });
export const deleteProject = projectId =>
    axios.delete(`/api/v1/projects/${projectId}`);
export const createTestSpace = projectId =>
    axios.post(`/api/v1/projects/${projectId}/testspace`);
export const fetchTestSpace = projectId =>
    axios.get(`/api/v1/projects/${projectId}/testspace/admin`);

export const fetchServiceAccounts = projectId =>
    axios.get(`/api/v1/projects/${projectId}/service-accounts`);

export const createServiceAccount = (projectId, params) =>
    axios.post(`/api/v1/projects/${projectId}/service-accounts`, params);

export const updateServiceAccountKeypair = (projectId, serviceAccountId) =>
    axios({
        method: "patch",
        url: `/api/v1/projects/${projectId}/service-accounts/${serviceAccountId}/keypair`,
        responseType: "blob"
    }).then(res => {
        const name = res.headers["content-disposition"].split("filename=")[1];
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = res.data;
            window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
            const url = window.URL.createObjectURL(
                new Blob([res.data], { type: res.headers["content-type"] })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        }
    });

export const deleteServiceAccount = (projectId, serviceAccountId) =>
    axios.delete(
        `/api/v1/projects/${projectId}/service-accounts/${serviceAccountId}`
    );

export const fetchAppDetail = appId => axios.get(`/api/v1/apps/${appId}`);
export const updateAppDetailApi = (appId, data) =>
    axios.patch(`/api/v1/apps/${appId}/oauth`, data);
export const updateAppDetail = (appId, data) =>
    axios.put(`/api/v1/apps/${appId}`, data);
export const fetchAppCategories = (type = "EDU") =>
    axios.get("/api/v1/apps/categories", { params: { type } });
export const registerApp = data => axios.post("/api/v1/apps", data);
export const deleteApp = appId => axios.delete(`/api/v1/apps/${appId}`);
export const cancelUpdate = appId =>
    axios.post(`/api/v1/apps/${appId}/cancel/update`);
export const fetchMyCustomers = appId =>
    axios.get(`/api/v1/apps/${appId}/acl`);
export const updateMyCustomers = (appId, data) =>
    axios.post(`/api/v1/apps/${appId}/acl`, data);

export const fetchCustomersTypes = () => axios.get("/api/v1/customers/types");
export const fetchCustomers = params =>
    axios.get("/api/v1/customers", { params });

export const uploadPhoto = async (appId, formData) => {
    const apiUrl = await getPhupAPIUrl(appId);
    const headers = { "Content-Type": "multipart/form-data" };

    const { data } = await axios.post(apiUrl, formData, { headers });
    const xml = new DOMParser().parseFromString(data, "text/xml");
    const url = xml.querySelector("url").textContent;
    return getPhinfImageUrl(url);
};

/** @see https://oss.navercorp.com/whale/whalespace-admin/wiki/%5BGSaas%5D-%ED%86%B5%ED%95%A9-%EC%9D%B8%EC%A6%9D-%EB%B0%8F-%ED%94%84%EB%A1%9C%ED%95%84-API#%ED%86%B5%ED%95%A9-%EC%95%B1-%EC%BD%98%EC%86%94-%EA%B6%8C%ED%95%9C-%EC%9A%94%EC%B2%AD */
export const requestAppConsoleAuth = param =>
    axios.post("/api/v1/saas/console/applications", param);

const getPhupAPIUrl = async appId => {
    const { VUE_APP_PHINF_UPLOAD: domain } = process.env;
    const { data: { sessionKey, idNo } } = await fetchPhupSession(appId);
    const param = new URLSearchParams({
        serviceName: "whalespace",
        sessionKey,
        userId: idNo
    }).toString();
    return `${domain}/${sessionKey}/simpleUpload/0?${param}`;
};

const fetchPhupSession = appId =>
    axios.get(`/api/v1/apps/${appId}/image/session`);

const getPhinfImageUrl = path => {
    const { VUE_APP_PHINF_URL: domain } = process.env;
    const url = new URL(domain);
    url.pathname = path;
    return url.toString();
};
